import BackendService from "./BackendService";

async function createEstimate(data) {
  return BackendService.post("/estimates/", data);
}

async function getHighestEstimateNo() {
  const highestEstimateObj = await BackendService.get("/estimates/highest-estimate-no/");

  return highestEstimateObj?.data?.highest_estimate_no;
}

async function updateEstimate(id, data) {
  return BackendService.patch(`/estimates/${id}/`, data);
}

async function getEstimateDetails(id) {
  return BackendService.get(`/estimates/${id}/`);
}

const EstimateService = {
  createEstimate,
  updateEstimate,
  getHighestEstimateNo,
  getEstimateDetails,
};

export default EstimateService;
